"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formProps = void 0;

require("core-js/modules/es.number.constructor.js");

var formProps = {
  size: {
    type: String,
    default: 'medium',
    validator: sizeValidator
  },
  showResetBtn: {
    type: Boolean,
    default: false
  },
  showSubmitBtn: {
    type: Boolean,
    default: true
  },
  inline: {
    type: Boolean,
    default: false
  },
  fuzzy: {
    type: Boolean,
    default: true
  },
  labelWidth: Number,
  itemWidth: Number,
  submitHandler: Function,
  submitLoading: {
    type: Boolean,
    default: false
  },
  submitBtnText: {
    type: String,
    default: '搜索'
  },
  resetBtnText: {
    type: String,
    default: '重置'
  },
  resetBtnCallback: Function,
  forms: {
    type: Array,
    required: true
  }
};
exports.formProps = formProps;

function sizeValidator(value) {
  var methodTypes = ['large', 'medium', 'small', 'mini'];
  var valid = methodTypes.indexOf(value.toLowerCase()) !== -1 || value === '';

  if (!valid) {
    throw new Error("\u7EC4\u4EF6\u5927\u5C0F\u53EA\u80FD\u8BBE\u7F6E ['large','medium','small','mini']");
  }

  return valid;
} // function itemTypeValidator(value) {
//   const methodTypes = ['input', 'select', 'date', 'daterange'];
//   const valid = methodTypes.indexOf(value.toLowerCase()) !== -1
//   if (!valid) {
//     throw new Error(`ItemType must be one of ['input', 'select', 'date', 'daterange']`)
//   }
//   return valid
// }